import { Society } from 'types';
import { isPlatformAXA } from 'utils/showDetails';

import { getCommunication } from './getCommunication';
import { getTemplate } from './getTemplate';

type Props = {
  subject: string;
  actualSociety: Society;
  userId: string;
  operationId: string;
};

export const getEmailData = ({
  subject,
  actualSociety,
  userId,
  operationId,
}: Props) => {
  const societyLanguage = actualSociety?.societyLanguage || 'es';
  const template = getTemplate(societyLanguage);

  const emailData: Record<string, unknown> = {
    subject,
    template,
    operationId,
    templateData: [
      {
        name: 'societyName',
        content: actualSociety?.name,
      },
    ],
    user: userId,
    society: actualSociety?._id,
    date: new Date(),
    status: 'SENT',
  };

  if (!isPlatformAXA) {
    emailData.templateBody = getCommunication(actualSociety);
  }

  return emailData;
};
